// extracted by mini-css-extract-plugin
module.exports = {"button":"SingInButton-module--button--1Ka0N","wrapper":"SingInButton-module--wrapper--KvvEc","disabled":"SingInButton-module--disabled--2olx9"};